<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="SEGURIDAD SOCIAL" key="1">
          <contract-person @contractSelected="contractSelected"/>
          <employee-social-security v-if="idEmp" :empleadoseleccionado="idEmp" :isHumanManagement="true"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
    export default {
      data () {
        return {
          idEmp: null
        }
      },
      methods: {
        contractSelected (idEmp) {
          this.idEmp = idEmp
        }
      }
    }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadSocial/SeguridadSocial.vue